// extracted by mini-css-extract-plugin
module.exports = {"author-img":"author-image_author-img__AH_oq","hidden":"author-image_hidden___9sJc","edit-icon-container":"author-image_edit-icon-container__AiXzW"};